import { render, staticRenderFns } from "./BuildingPositions.vue?vue&type=template&id=4cc3a672"
import script from "./BuildingPositions.vue?vue&type=script&lang=js"
export * from "./BuildingPositions.vue?vue&type=script&lang=js"
import style0 from "./BuildingPositions.vue?vue&type=style&index=0&id=4cc3a672&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports